/* eslint-disable */
import { Alert } from 'react-native'
import { AsyncStorage } from '@react-native-async-storage/async-storage'
import { NavigationActions } from 'react-navigation'
import I18n from "i18n-js"
import { reset, SubmissionError,stopSubmit } from 'redux-form';
import { call, put, select } from 'redux-saga/effects'
import { path } from 'ramda'

import UserActions from '../Redux/UserRedux'
import AuthActions from '../Redux/AuthRedux'
import {responseToChanges, exceptionToChanges, getDeviceCurrency} from '../Lib/utils'
// import { CURRENCY_SELECTOR } from '../Constant/index'


export const readUser = function* readUser(api, action) {
  try {
    const { userId } = action
    // make the call to the api
    let response = yield call(api.readUser, userId)
    if (response.ok) {
      const { data } = response
      const apiResponse = data
      const user = Object.assign({}, apiResponse.data[0])
      // const fullState = yield select() // the entire app state
      console.tron.display({name: 'readUser',preview: "calling authUpdateRequest",value: {user: user}})
      // yield call(AuthActions.updateAuthUser, user)
      if (user.hasOwnProperty('Language') && user.Language !== I18n.locale) {
        I18n.locale = user.Language
      }
      yield put(AuthActions.authUpdateRequest(user))
      yield put(UserActions.readSuccess(response))
    } else {
      yield put(UserActions.readFailure(response))
    }
  } catch (e) {
    yield put(UserActions.readFailure(e))
    console.tron.display({name: 'readUser error',preview: "expand",value: {message: e.message,e: e}})
  }
}
export const readOtherUser = function* readUser(api, action) {
  try {
    let response = yield call(api.readUser, action.userId)
    if(response.ok) {
      const apiResponse = response.data
      const user = Object.assign({}, apiResponse.data[0])
      yield put(AuthActions.authUpdateRequest(user))
      yield put(UserActions.readOtherSuccess(response))
    }
    else yield put(UserActions.readOtherFailure(response))
  } catch (e) {
    yield put(UserActions.readOtherFailure(e))
  }
}
export const blockUser = function* blockUser(api, action) {
  try {
    const { data } = action
    let response
    if(data.isBlockUser) response = yield call(api.blockUser, data)
    else response = yield call(api.unBlockUser, data)
    if (response.ok) {
      console.tron.display({name: `blockUser sucesss`,preview :``,value: {state: response}})
      yield put(UserActions.blockUserSuccess({blockUser : data.isBlockUser}))
    } else {
      console.tron.display({name: `blockUser fail`,preview :``,value: {state: response}})
      yield put(UserActions.blockUserFailure(response))
    }
  }
  catch (e) {
    console.tron.display({name: 'blockUser error',preview: "expand",value: {message: e.message,e: e}})
  }
}

export const getBlockUser = function* getBlockUser(api, action) {
  try {

    const { data } = action
    const response = yield call(api.getBlockUser, data)
    if (response.ok) {
      yield put(UserActions.getBlockUserSuccess(response))
    } else {
      console.tron.display({name: `getBlockUser fail`,preview :``,value: {state: response}})
      yield put(UserActions.getBlockUserFailure(response))
    }
  }
  catch (e) {
    console.tron.display({name: 'getBlockUser error',preview: "expand",value: {message: e.message,e: e}})
  }
}
export const updateUser = function* updateUser(api, action) {
  try {
    const { changes: { changes, resolve = null, reject = null } } = action
    // make the call to the api
    const response = yield call(api.updateUser, changes)
    if (response.ok) {
      const { data } = response
      const apiResponse = data
      if (resolve) {
        yield call(resolve);
        yield put(stopSubmit('editForm'));
        yield put(NavigationActions.back())
      }

      const user = Object.assign({}, apiResponse.data[0])
      yield put(AuthActions.authUpdateRequest(user))

      yield put(UserActions.updateSuccess(response))

    } else {
      const { data: { errors } } = response
      const { fieldErrors } = errors[0]
      const error = fieldErrors[0]

      if (resolve)
        yield put(stopSubmit('editForm'))
      if (reject)
        yield call(reject,
          new SubmissionError({
            username: error.name == 'Username' && error.status,
            'first name': error.name == 'FirstName' && error.status,
            'last name': error.name == 'LastName' && error.status,
            email: error.name == 'Email' && error.status,
            bio: error.name == 'Bio' && error.status,
            phone: error.name == 'Phone' && error.status,
            'old password': error.name == 'old_password' && error.status,
            'new password': error.name == 'Password' && error.status,
            'confirm password': error.name == 'confirm_password' && error.status
          }))
      yield put(UserActions.updateFailure(response))
    }
  }
  catch (e) {
    yield put(UserActions.updateFailure(e))
    console.tron.display({
      name: 'updateUser error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }
}

export const setPushFlags = function* setPushFlags(api, action) {
  try {
    console.tron.display({
      name: 'AuthSagas set push notification flags'
      , preview: 'setting push notification flags based on user toggle input'
      , value: { action: action }
    })
    const { changes: { changes, resolve, reject } } = action
    // make the call to the api
    const response = yield call(api.updateUser, changes)

    if (response.ok) {
      const { data } = response
      const apiResponse = data
      console.tron.display({
        name: 'api setPushFlags (updateUser) apiResponse (setting User.NotifyAccept)'
        , preview: 'expand'
        , value: { apiResponse: apiResponse }
      })
      yield call(resolve, response)
      yield put(UserActions.updateSuccess(response))
    } else {
      const { data: { errors } } = response
      yield call(reject, errors)
      yield put(UserActions.updateFailure(response))
    }
  } catch (e) {
    yield call(reject, e)
    yield put(UserActions.updateFailure(e))
    console.tron.display({
      name: 'error setting NotifyAccept'
      , preview: 'expand'
      , value: {
        message: e.message
        , e: e
      }
    })
  }
}

export const addAddress = function* addAddress(api, action) {
  try {
    const { address } = action
    const response = yield call(api.updateUser, address)
    if (response.ok) {
      const { data } = response
      const apiResponse = data

      yield put(UserActions.addAddressSuccess(response))

      // if (address.hasOwnProperty('index')) {
      yield put(reset('DeliveryAddressesForm'));
      // }
    } else {
      yield put(UserActions.addAddressFailure(new Error()))
    }
  }
  catch (e) {
    yield put(UserActions.addAddressFailure(e))
  }
}

export const updateTouchId = function* updateTouchId(api, action) {
  try {
    const { changes: { changes, resolve, reject } } = action
    // make the call to the api
    const response = yield call(api.updateUser, changes)

    if (response.ok) {
      yield call(resolve)
      yield put(UserActions.updateTouchIdSuccess(response))
    } else {
      const { data: { errors } } = response
      yield call(reject)
      yield put(UserActions.updateTouchIdFailure(errors))
    }
  } catch (e) {
    yield call(reject, e)
    yield put(UserActions.updateTouchIdFailure(e))
  }
}
export const resetPass = function* resetPass(api, action) {

  try {

    const {data : {   email ,resolve, reject } } = action


    // make the call to the api
    const response = yield call(api.resetPass, email)
    console.tron.display({
      name: `resetPass saga`,
       preview :``,
      value: {
      state: response
      }
      })

    if (response.ok) {
      yield call(resolve)
      yield put(stopSubmit('ForgetForm'));
      yield put(UserActions.resetPassSuccess(response))
    } else {
      console.tron.display({
        name: `resetPass failt`,
         preview :``,
        value: {
        state: response
        }
        })


      const { data: { errors } } = response

      const error = errors[0]

      yield put(stopSubmit('ForgetForm'));
      yield call(reject, new SubmissionError({ email: error.detail }));

      yield put(UserActions.resetPassFailure(errors))
    }
  } catch (e) {
    console.tron.display({
    name: `resetPass error`,
     preview :``,
    value: {
    state: e
    }
    })

  }
}

export const updateKargoeCare = function* updateKargoeCare(api, action) {
  try {
    const { changes } = action
    // make the call to the api

    const response = yield call(api.updateUser, changes)

    if (response.ok) {
      console.tron.display({
        name: `response`,
        preview: ``,
        value: {
          state: response
        }
      })
      const apiResponse = response.data
      const user = Object.assign({}, apiResponse.data[0])
      yield put(AuthActions.authUpdateRequest(user))

      yield put(UserActions.updateKargoeCareSuccess(response))
    } else {
      const { data: { errors } } = response
      yield put(UserActions.updateKargoeCareFailure(errors))
    }
  } catch (e) {
    yield put(UserActions.updateKargoeCareFailure(e))
  }
}

export const listFollowing = function * listFollowing (api, action) {
  try {
    let { params : {UserId, next} } = action
    console.tron.display({name: 'UserSagas', preview: `listFollowing`, value: {action: action, UserId: UserId, next: next}})
    const response = yield call(api.getFollowing, UserId, {start: next})
    console.tron.display({name: 'UserSagas', preview: `listFollowing response`, value: {response: response}})
    if( response.ok )
      yield put(UserActions.listFollowingSuccess(response))
    else
      yield put(UserActions.listFollowingFailure(response.data.errors))
  } catch (e) {
    yield put(UserActions.listFollowingFailure(e))
  }
}
export const listFollowers = function * listFollowers (api, action) {
  try {
    let { UserId : {UserId, next} } = action
    if( typeof next === 'undefined' ) return // abort
    const response = yield call(api.getFollowers, { UserId : UserId, next : next })
    if( response.ok ) {
      response.next = next
      yield put(UserActions.listFollowersSuccess(response))
    } else yield put(UserActions.listFollowersFailure(response.data.errors))
  } catch (e) {
    yield put(UserActions.listFollowersFailure(e))
  }
}


export const outofdate = function* outofdate(api) {
  try {
    yield put(UserActions.outofdate( ))
  } catch (e) {
    console.log("but how?")
  }
}

export const refreshAvatar = function* refreshAvatar( ) {
  try {
    yield put(UserActions.refreshAvatar( ))
  } catch (e) {
    console.log("but how?")
  }
}

export const getExchangeRates = function* getExchangeRates(api, action) {
  try {
    console.tron.log(`UserSagas getExchangeRates`)
    // cases where token has not been set yet
    const state = yield select()
    const token = state.auth.token
    const userCurrency = state.auth.user ? state.auth.user.Currency : 'USD' 
    yield call(api.setAuthorization, token)
    const response = yield call(api.getCurrencyExchangeRates)
    console.tron.display({ name: 'getExchangeRates', preview: 'expand', value: { response } })
    if (response.ok) {
      const apiResponse = response.data
      let rawRates = apiResponse.data
      let quotes = rawRates.quotes
      const minimumAmount = rawRates.minimumAmount
      const changes = {
        phase: 'success',
        modified: Date.now(),
        logRef: apiResponse.logRef,
        userCurrency,
        rates: quotes,
        minimumAmount,
      }
      yield put(UserActions.userSuccess('exchangeRates', changes))
    }
    else {
      yield put(UserActions.userFailure('exchangeRates', responseToChanges("Get Exchange Rates Exception", response)))
    }
  }
  catch (error) {
    yield put(UserActions.userFailure('exchangeRates', exceptionToChanges("Get Exchange Rates Exception", error)))
  }
}

export const setUserDefaultCurrency = function* updateUser(api, action) {
  try {
    const { auth } = yield select()
    if (!auth.user) {
      console.tron.log(`setUserDefaultCurrency - not logged in`)
      return
    }
    const userCurrency = getDeviceCurrency()
    console.tron.display({name: `UserSagas`, preview : `setUserDefaultCurrency1 Currency...`, value: {userCurrency, auth}})
    console.log(`setUserDefaultCurrency ${userCurrency}`)
    const changes = {
      UserId: auth.user.UserId,
      Currency: userCurrency
    }
    const response = yield call(api.updateUser, changes)
    console.tron.display({name: 'UserSagas', preview: "setUserDefaultCurrency2", value: {auth, changes, response}})
    if (response.ok) {
      const { data } = response
      const apiResponse = data
      const user = Object.assign({}, apiResponse.data[0])
      yield put(AuthActions.authUpdateRequest(user))
      yield put(UserActions.updateSuccess(response))
    } else {
      yield put(UserActions.updateFailure(response))
    }
  }
  catch (e) {
    yield put(UserActions.updateFailure(e))
    console.tron.display({name: 'UserSagas', preview: "setUserDefaultCurrency3", value: {error: e, errorMessage: e.message}})
  }
}
